import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play",
  "use": "play-usage",
  "viewBox": "0 0 50 60",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 60\" id=\"play\"><title>play</title><path d=\"M45.792 34.293L9.544 57.253C6.232 59.307 2 56.88 2 52.96V7.04C2 3.12 6.232.693 9.544 2.747l36.248 22.96c2.944 2.053 2.944 6.533 0 8.586\" stroke=\"#FFF\" stroke-width=\"4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol